import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Paper,
  Divider,
  Chip,
} from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

function ReassignLogsDialog({
  reassignLogsDialogOpen,
  setReassignLogsDialogOpen,
  reassignLogsLoading,
  reassignLogsError,
  reassignLogs,
  formatDateTime,
  renderReassignComment,
}) {
  return (
    <Dialog
      open={reassignLogsDialogOpen}
      onClose={() => setReassignLogsDialogOpen(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ backgroundColor: "primary.main", color: "white" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <SwapHorizIcon />
          Law Firm Re-Assignments
        </Box>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          mt: 1,
          maxHeight: 480,
          overflowY: "auto",
          backgroundColor: "#f8f9fa",
        }}
      >
        {reassignLogsLoading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 4,
            }}
          >
            <CircularProgress />
          </Box>
        )}

        {!reassignLogsLoading && reassignLogsError && (
          <Typography
            variant="body2"
            sx={{ color: "error.main", textAlign: "center", py: 2 }}
          >
            {reassignLogsError}
          </Typography>
        )}

        {!reassignLogsLoading &&
          !reassignLogsError &&
          (!reassignLogs || reassignLogs.length === 0) && (
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", textAlign: "center", py: 2 }}
            >
              No reassignment activity found for this law firm.
            </Typography>
          )}

        {!reassignLogsLoading &&
          Array.isArray(reassignLogs) &&
          reassignLogs.length > 0 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {reassignLogs.map((log) => (
                <Paper
                  key={log.reassignment_log_id}
                  elevation={1}
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "white",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, display: "flex", gap: 1 }}
                    >
                      <span>{log.lawfirm_name || "Law Firm"}</span>
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flexWrap: "wrap",
                      }}
                    >
                      {log.role && (
                        <Chip
                          label={log.role}
                          size="small"
                          color={
                            log.role === "Attorney" ? "primary" : "secondary"
                          }
                        />
                      )}
                      <Typography
                        variant="caption"
                        sx={{ color: "text.secondary" }}
                      >
                        {formatDateTime(log.created_at)}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    <strong>From:</strong>{" "}
                    {log.lawfirm_user_from || "Unassigned"}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    <strong>To:</strong> {log.lawfirm_user_to || "N/A"}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    <strong>Comment:</strong>{" "}
                    {renderReassignComment(log.comment)}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: "text.secondary" }}
                  >
                    <strong>Updated By:</strong> {log.created_by || "Unknown"}
                  </Typography>
                </Paper>
              ))}
            </Box>
          )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={() => setReassignLogsDialogOpen(false)}
          variant="outlined"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReassignLogsDialog;
